import React from 'react';
import './StageHeader.css';

interface StageHeaderProps {
  title: string;
  subtitle?: string;
  stats?: { label: string; value: string }[];
}

const StageHeader: React.FC<StageHeaderProps> = ({ title, subtitle, stats = [] }) => {
  return (
    <div className="stage-header">
      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="stage-stats">
        {stats.map((s, i) => (
          <div key={i} className="stage-stat">
            <span className="label">{s.label}</span>
            <span className="value">{s.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StageHeader;
